import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Document\MigrateLocalDocumentToDocumentLibraryController::__invoke
* @see app/Http/Controllers/Document/MigrateLocalDocumentToDocumentLibraryController.php
* @route '/api/document/{document}/copy-local-to-library'
*/
const MigrateLocalDocumentToDocumentLibraryController = (args: { document: string | number | { id: string | number } } | [document: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: MigrateLocalDocumentToDocumentLibraryController.url(args, options),
    method: 'put',
})

MigrateLocalDocumentToDocumentLibraryController.definition = {
    methods: ["put"],
    url: '/api/document/{document}/copy-local-to-library',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Document\MigrateLocalDocumentToDocumentLibraryController::__invoke
* @see app/Http/Controllers/Document/MigrateLocalDocumentToDocumentLibraryController.php
* @route '/api/document/{document}/copy-local-to-library'
*/
MigrateLocalDocumentToDocumentLibraryController.url = (args: { document: string | number | { id: string | number } } | [document: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { document: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { document: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            document: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        document: typeof args.document === 'object'
        ? args.document.id
        : args.document,
    }

    return MigrateLocalDocumentToDocumentLibraryController.definition.url
            .replace('{document}', parsedArgs.document.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Document\MigrateLocalDocumentToDocumentLibraryController::__invoke
* @see app/Http/Controllers/Document/MigrateLocalDocumentToDocumentLibraryController.php
* @route '/api/document/{document}/copy-local-to-library'
*/
MigrateLocalDocumentToDocumentLibraryController.put = (args: { document: string | number | { id: string | number } } | [document: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: MigrateLocalDocumentToDocumentLibraryController.url(args, options),
    method: 'put',
})

export default MigrateLocalDocumentToDocumentLibraryController